import React from 'react'

type MasterLogoProps = {
  className?: string
}

const MasterLogo = ({ className }: MasterLogoProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="24"
      fill="none"
      viewBox="0 0 56 24"
    >
      <g fill="#6BC8BB" clipPath="url(#clip0_675:4852)">
        <path d="M35.774 0c4.73 0 8.013 2.883 8.013 7.275 0 3.15-1.806 5.664-5.451 7.508l-3.547 1.81c-1.314.704-2.89 1.844-2.89 3.286h11.888v3.854h-16.19v-3.251c0-3.788 3.12-6.268 5.32-7.375l3.68-1.877c1.87-.939 2.823-2.28 2.823-3.989 0-2.18-1.412-3.586-3.645-3.586-2.463 0-3.875 1.91-3.81 4.76h-4.368C27.497 3.218 30.75 0 35.774 0zM55.814 3.32V.25h-3.78v1.342c0 .69-.268 1.35-.746 1.838a2.522 2.522 0 01-1.8.762h-2.549v3.657h4.437c.033 0 .065-.004.098-.005v15.887h4.339V3.32v.002zM4.857 0c1.289 0 2.524.522 3.435 1.452a5.01 5.01 0 011.423 3.506v4.958H4.857a4.808 4.808 0 01-3.434-1.452A5.01 5.01 0 010 4.958a5.01 5.01 0 011.423-3.506A4.808 4.808 0 014.857 0zM0 19.042a5.01 5.01 0 011.423-3.506 4.808 4.808 0 013.434-1.452h4.858v4.958a5.01 5.01 0 01-1.423 3.506A4.808 4.808 0 014.857 24a4.808 4.808 0 01-3.434-1.452A5.01 5.01 0 010 19.042zM18.655 24a4.808 4.808 0 01-3.435-1.452 5.01 5.01 0 01-1.423-3.506v-4.958h4.858c1.288 0 2.523.522 3.434 1.452a5.01 5.01 0 011.423 3.506 5.01 5.01 0 01-1.423 3.506A4.808 4.808 0 0118.655 24zM23.512 4.958a5.01 5.01 0 01-1.423 3.506 4.808 4.808 0 01-3.434 1.452h-4.858V4.958a5.01 5.01 0 011.423-3.506A4.808 4.808 0 0118.655 0c1.288 0 2.523.522 3.434 1.452a5.01 5.01 0 011.423 3.506z"></path>
      </g>
      <defs>
        <clipPath id="clip0_675:4852">
          <path fill="#fff" d="M0 0H55.814V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default MasterLogo
